module.exports = __webpack_public_path__ + "img/2f_r_horse.c4d7d1ba.jpg";